<template>
  <div v-loading="fullScreenLoading">
    <el-upload
      drag
      :action="uploadURL"
      :before-upload="beforeUpload"
      :multiple=false
      :http-request="uploadFile"
      :show-file-list="false"
      :file-list="file">
      <i class="el-icon-upload"></i>
      <div class="el-upload__text" style="line-height:18px;">{{$t('common.imageUpload.instruction1')}}<em>{{$t('common.imageUpload.instruction2')}}</em></div>
      <!-- <div class="el-upload__tip" slot="tip">Fichiers Excel avec une taille inférieure à 500kb</div> -->
    </el-upload>
    <el-row class="text-center">
      <el-button @click="openGaleryDialog">{{$t('common.imageUpload.addFromLibrary')}}</el-button>
    </el-row>
    <GalleryDialog :dialogVisible="galleryDialogVisible" :selection="true" :multiple="enabledMutlipleImageSelection" @close="closeGaleryialog" @select="handleSelection"></GalleryDialog>
  </div>
</template>
<script>

import cmsAPI from '@/services/API/cmsAPI'
import imageUtil from '@/utils/image-util.js'
import GalleryDialog from './gallery-dialog'
import { mapActions, mapState, mapGetters } from 'vuex';

export default {
  name: 'image-upload-widget',
	props: {
    preSelectedType : Number,
    enabledMutlipleImageSelection : {
      type : Boolean,
      default : false
    },
    typeId : {type : Number, required:true}
	},
  data() {
    return {
      galleryDialogVisible : false,
      file  : [],
      fullScreenLoading : false,
      model : {
        assetId : null,
        thumbnailLink : null,
        link : null,
        description : {fr : "", en : ""},
        code : null,
      },
      selectedType : null,
      asset : null,
    };
  },components: {
    GalleryDialog
  },
	methods: {
    handleSelection(asset){
      this.$emit('select', asset);
    },
    openGaleryDialog(multiple){
      this.galleryDialogVisible=true;
    },
    closeGaleryialog(){
      this.galleryDialogVisible = false;
      this.$emit('close');
    },
    beforeUpload(){
      this.fullScreenLoading=true;
    },
    resetFields(){
      this.file = [];
      this.asset = null;
      this.model.link = null;
      this.model.type_id = null;
      this.model.thumbnailLink = null;
      this.model.description = {fr : "", en : ""},
      this.model.code = null;

    },
    buildGalleryObjectModel(){
      return {
        assetId : this.model.assetId,
        thumbnailLink : this.model.thumbnailLink,
        link : this.model.link,
        type : {
          id : this.typeId
        },
        assetInfo : this.asset,
        code : this.model.code,
        description : this.model.description
      }
    },

    save(){
      let gallery = this.buildGalleryObjectModel();
      return cmsAPI.saveGallery(gallery)
        .then(galleryCreated=>{
          return cmsAPI.getCMSGalleries(galleryCreated.id)
            .then(galery=>{
              this.$emit('select',[galery]);
              this.resetFields();
              this.fullScreenLoading = false
            })

        }).catch(err=>{
          this.$message.error("Une erreur est survenue. Veuillez réessayer plus tard.");
        })
    },
    handleUploadSuccess(response){
      this.fullScreenLoading = false;
      this.asset = response.data;
      this.model.link = this.asset.secure_url;
      this.model.assetId = this.asset.asset_id;
      this.model.thumbnailLink = this.asset.eager!=null && this.asset.eager.length>0 ? this.asset.eager[0].secure_url : null;
      if(this.model.code==null)this.model.code = this.asset.original_filename;
      return this.save();
    },
    handleUploadError(err){
      this.fullScreenLoading = false;
      this.$message.error('Une erreur est survenue lors lors du téléversement du fichier... Veuillez réessayer plus tard.');
    },
    uploadFile(uploadForm){
      this.fullScreenLoading = true;
      return imageUtil.uploadFile(uploadForm.file, this.handleUploadSuccess, this.handleUploadError)
    }
	},
	computed: {
    uploadURL(){
       return process.env.VUE_APP_CLOUDINARY_URL;
    },
	}
}
</script>
<style lang="scss" scoped>
@import '../../../../assets/scss/_variables';

.title {
	font-size : 1.8em;
	font-weight:bold;

}

.el-form-item{
  margin-bottom:20px;
}

.el-col-xs-24{
    margin-left:25%;
    width:50%;
  }

  .dialog-footer{
    position: fixed;
    display: block;
    bottom: 0px;
    width: 100%;
    background-color: #f3f7fa;
    height:50px;
    margin-left:-20px;
    padding-top:10px;
    border-top:1px solid #E4E7ED;
    z-index:100;
  }

  .item {
    //padding: 20px;
    //margin: 20px 0;
    margin-bottom: 20px;
    //border-radius: 5px;
    opacity: .85;
    transition: all .25s;

    /* masonry */
    //display: inline-block;
    box-sizing: border-box;
    width: 100%;

    img {
      width: 100%;
      max-width: 100%;
    }

    &:hover {
      cursor:pointer;
      opacity: 1;
      box-shadow: 0px 0px 0px 4px $text-color-accent;
    }
  }

@media (max-width: 1366px) {
  .el-col-xs-24{
      margin-left:15%;
      width:60%;
    }
}

@media (max-width: 1080px) {
  .el-col-xs-24{
      margin-left:2%;
      width:100%;
    }
  }
</style>
